import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { JobPointeTransferService } from '../job-pointe-transfer.service';
import { isObservable, Subscription } from 'rxjs';
import { ToastService } from 'src/app/service/shared/toast/toast.service';
@Component({
  selector: 'app-job-board-card',
  templateUrl: './job-board-card.component.html',
  styleUrls: ['./job-board-card.component.scss'],
})
export class JobBoardCardComponent implements OnInit {
  isJobCardModalOpen: boolean = false;
  modalSubscription: Subscription;
  rowSubscription: Subscription;
  selectedRow: any = {};
  jobCardDisplayMethod: any;
  @ViewChild('jobCardModal') jobCardModal: ElementRef;
  @HostListener('document:click', ['$event'])
  clickedOut(event) {
    if (!this.jobCardModal?.nativeElement) return;
    if (event.target.className.includes('overlay')) this.handleClose();
  }

  constructor(
    private jobPointeTransferService: JobPointeTransferService,
    private toastService: ToastService,
  ) {}

  ngOnInit(): void {
    this.modalSubscription = this.jobPointeTransferService.isJobCardModalOpen.subscribe(value => {
      if (value) {
        this.selectedRow = value;
        this.isJobCardModalOpen = true;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.modalSubscription) this.modalSubscription.unsubscribe();
  }

  async toggleJobOnJobBoard(event) {
    let result = await this.jobPointeTransferService.toggleJobOnJobBoard(this.selectedRow, event.target.checked);
    if (!isObservable(result)) return (event.target.checked = this.selectedRow.isOnJobBoard);
    result.subscribe(
      res => {
        this.selectedRow.isOnJobBoard = event.target.checked;
        this.jobPointeTransferService.refreshData();
      },
      err => {
        this.toastService.showToast('An error occurred toggling job on job board', 'error');
        event.target.checked = this.selectedRow.isOnJobBoard;
        console.error('error:', err);
      },
    );
  }
  async toggleJobSeparateOnJobBoard(event) {
    let result = await this.jobPointeTransferService.toggleJobSeparateOnJobBoard(
      this.selectedRow,
      event.target.checked,
    );
    if (!isObservable(result)) return (event.target.checked = this.selectedRow.isSeparateOnJobBoard);
    result.subscribe(
      res => {
        this.selectedRow.isSeparateOnJobBoard = event.target.checked;
        this.jobPointeTransferService.refreshData();
      },
      err => {
        this.toastService.showToast('An error ocurred toggling separate job on job board', 'error');
        event.target.checked = this.selectedRow.isSeparateOnJobBoard;
        console.error('error:', err);
      },
    );
  }
  handleClose() {
    this.isJobCardModalOpen = false;
    this.jobPointeTransferService.close();
  }
}
